/**
 * @file media
 * @author fuqiang15
 */
const padTime = val => {
    return Number(val) >= 9 ? `${val}` : `0${val}`;
};

export function timeDisplay(val) {
    if (val == null) {
        return '-';
    }
    val = Number(val).toFixed(0);
    let m = val % 3600;
    let s = (m % 60);
    let hour = (val - m) / 3600;
    let minute = padTime((m - s) / 60);
    return hour ? `${hour}:${minute}:${padTime(s)}` : `${minute}:${padTime(s)}`;
}

export default {
    props: {
        src: String,
        autoPlay: Boolean
    },
    data() {
        return {
            loading: true,
            error: null,
            canPlay: null,
            currentTime: null,
            totalTime: null,
            playing: false
        };
    },
    computed: {
        realCurrentTime() {
            return this.currentTime == null
                ? this.totalTime == null ? null : '0'
                : this.currentTime;
        },
        iconName() {
            return this.playing ? 'pause' : 'play';
        },
        percent: {
            get() {
                if (this.currentTime && this.totalTime) {
                    return this.currentTime;
                }
                return 0;
            },
            set(val) {
                this.currentTime = val;
                this.$refs.media.currentTime = val;
            }
        },
        showControl() {
            return !this.loading && !this.error;
        },
        mediaListeners() {
            return {
                loadedmetadata: this.handleLoadedMetadata,
                canplay: this.handleCanPlay,
                timeupdate: this.handleTimeUpdate,
                ended: this.handleEnded,
                loadeddata: this.handleLoad,
                loadstart: this.handleLoadStart,
                error: this.handleError
            };
        }
    },
    filters: {
        time(val) {
            return timeDisplay(val);
        }
    },
    methods: {
        playOrPause() {
            let method = this.playing ? 'pause' : 'play';
            this[method]();
        },
        play() {
            this.playing = true;
            this.$refs.media.play();
        },
        pause() {
            this.playing = false;
            this.$refs.media.pause();
        },
        handleLoadStart() {
            this.loading = true;
        },
        handleLoadedMetadata() {
            this.totalTime = this.$refs.media.duration;
        },
        handleCanPlay() {
            this.canPlay = true;
        },
        handleTimeUpdate() {
            this.currentTime = this.$refs.media.currentTime;
        },
        handleEnded() {
            this.currentTime = 0;
            this.pause();
        },
        handleLoad() {
            this.loading = false;
            if (this.autoPlay) {
                this.play();
            }
        },
        handleError(e) {
            const errorInfo = e.target.error;
            this.loading = false;
            this.error = `错误码：${errorInfo.code}；详细：${errorInfo.message}`;
        }
    }
};
